module.exports = __webpack_public_path__ + "img/logo-sm-green.579d2b96.svg";